import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface SittingResponse {
  activeStoreId: string;
  activeDiningTableId: string | null;
  isActive: boolean;
}

const ActiveDiningTableSitting: React.FC = () => {
  const { store_id, dining_table_id } = useParams<{ store_id: string; dining_table_id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSitting = async () => {
      try {
        const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/public/orders/stores/${store_id}/dining-tables/${dining_table_id}/sitting`);
        const data: SittingResponse = await response.json();
        
        if (data.isActive && data.activeDiningTableId) {
          navigate(`/public/active/${data.activeStoreId}/${data.activeDiningTableId}/order`, { replace: true });
        } else {
          // Handle the case where there is no active dining table
          console.error('No active dining table found');
        }
      } catch (error) {
        console.error('Error fetching sitting data:', error);
      }
    };

    fetchSitting();
  }, [store_id, dining_table_id, navigate]);

  return <div>Loading...</div>;
};

export default ActiveDiningTableSitting;
